module.exports = __webpack_public_path__ + "static/media/pic4-min.ba166b30.jpg";